module.exports = __webpack_public_path__ + "static/img/3.ac5d864.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/sp/3.png
// module id = JUpg
// module chunks = 0